export type UserRole =
  | 'ROLE_DEV'
  | 'ROLE_RETAILER'
  | 'ROLE_USER'
  | 'ROLE_ADMIN'
  | 'ROLE_SUPERADMIN'
  | 'ROLE_SUPPORT'
  | 'ROLE_CONFIG';

export interface Account {
  id: number;
  username: string;
  email: string;
  firstname: string;
  lastname: string;
  fullname: string;
  roles: UserRole[];
  primaryRole: UserRole | null;
  roleLabel: string;
  createdAt: string | null;
  // Detailed fields
  schoolCount?: number;
}

export interface AccountsResponse {
  data: Account[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface AccountsStats {
  total: number;
  roles: Record<UserRole, number>;
}

export interface AccountFilters {
  role?: string;
  search?: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export const ROLE_LABELS: Record<UserRole, string> = {
  ROLE_DEV: 'Developpeur',
  ROLE_RETAILER: 'Apporteur d\'affaires',
  ROLE_USER: 'Contributeur',
  ROLE_ADMIN: 'Lead developpeur',
  ROLE_SUPERADMIN: 'Administrateur',
  ROLE_SUPPORT: 'Support',
  ROLE_CONFIG: 'Configuration',
};

export const ROLE_COLORS: Record<UserRole, string> = {
  ROLE_DEV: 'purple',
  ROLE_RETAILER: 'blue',
  ROLE_USER: 'gray',
  ROLE_ADMIN: 'orange',
  ROLE_SUPERADMIN: 'red',
  ROLE_SUPPORT: 'green',
  ROLE_CONFIG: 'yellow',
};
